import React, {useMemo} from 'react';
import {Props} from './Props';
import {createValidDate, formatDate} from '../../utils/DateUtil';

const DateFormatted: React.FunctionComponent<Props> = ({dateTime}) => {
    const dateFormatted = useMemo(() => {
        const date = createValidDate(dateTime);
        if (!date) {
            return <>-</>;
        }

        return formatDate(date);
    }, [dateTime]);

    return <span>{dateFormatted}</span>;
};

export default DateFormatted;
